import React from 'react';
import styled from 'styled-components';

interface MainCardProps {
    children: React.ReactNode;
    width?: string;
    height?: string;
}

const StyledMainCard = styled.div<Pick<MainCardProps, 'width' | 'height'>>`
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(224, 224, 224, 1);
    padding: 40px;
    border-radius: 40px;
    width: ${({width}) => width || 'auto'};
    height: ${({height}) => height || 'auto'};
    min-width: 70%;
    display: flex;
    flex-direction: column;
`;

const MainCard: React.FC<MainCardProps> = ({children, width, height}) => {
    return <StyledMainCard width={width} height={height}>{children}</StyledMainCard>;
};

export default MainCard;
